import { Listing } from "@cma/chat-widgets/find-listings-search/types/Listing";
import { PropertyDto } from "@cma/shared/apis/comps/cma/generated";
import { MapPropertyItemDto } from "@shared/apis/sidekick/generated";

export const convertListingToPropertyDto = (listing: Listing): PropertyDto => {
  const property: PropertyDto = {
    id: listing.uPropertyId,
    mlsId: listing.mlsId,
    mlsSource: listing.mlsSource,
    addressLine1: listing.addressLine1,
    addressLine2: listing.addressLine2,
    baths: listing.numBathrooms || listing.bathroomCount,
    beds: listing.numBedrooms || listing.bedroomCount,
    latitude: listing.latitude,
    longitude: listing.longitude,
    listingStatus: listing.listingStatus?.listingStatus || "Unknown",
    buildingName: undefined, // Not available in Listing
    city: listing.city,
    description: listing.description,
    garageSpaces: listing.parkingGarageSpaces,
    hoaFees: listing.hoaMonthlyFee,
    hoaFee: listing.hoaFee,
    floor: undefined, // Not available in Listing
    listDate: listing.listDate ? new Date(listing.listDate) : undefined,
    listPrice: listing.listPrice,
    livingSpace: listing.internalSize,
    lotSize: listing.lotSize,
    neighborhood: listing.neighborhood,
    nonGarageSpaces: undefined, // Not available in Listing
    propertyStyle: undefined, // Deprecated field
    propertyStyles: undefined, // Not available in Listing
    propertyStyleOther: undefined, // Not available in Listing
    propertyType: listing.propertyType?.propertyType || "Unknown",
    propertyTypeOther: undefined, // Not available in Listing
    state: listing.state,
    yearBuilt: listing.yearBuilt,
    zipCode: listing.zipCode,
    renovationType: undefined, // Not available in Listing
    hasAdditionalLivingSpace: false, // Default value
    additionalLivingSpaceSqFt: undefined, // Not available in Listing
    images:
      listing.photos?.map((url, index) => ({
        id: index.toString(),
        url: url,
        cdnUrl: undefined,
        caption: undefined,
      })) || [],
    soldPrice: listing.soldPrice,
    soldDate: undefined, // Not available in Listing
    county: listing.county,
    smartResult: undefined, // Not available in Listing
    hasDoormanAttendance: listing.hasDoormanAttendance,
    listingAgent:
      listing.agents && listing.agents.length > 0
        ? {
            name: listing.agents[0].name || null,
            dre: null, // Not available in Listing
            brokerage: listing.agents[0].brokerage || null,
            lastSourceUpdateDate: listing.agents[0].lastSourceUpdateDate
              ? new Date(listing.agents[0].lastSourceUpdateDate)
              : null,
            phone: listing.agents[0].phone || null,
            email: listing.agents[0].email || null,
          }
        : {
            name: null,
            dre: null,
            brokerage: null,
            lastSourceUpdateDate: null,
            phone: null,
            email: null,
          },
    isLease: listing.isLease,
    roomsTotal: listing.unitCount,
    flipTaxRemarks: undefined, // Not available in Listing
    recurringCosts: undefined, // Not available in Listing
  };

  return property;
};

export const convertMapListingToPropertyDto = (
  listing: MapPropertyItemDto
): PropertyDto => {
  const property: PropertyDto = {
    id: listing.id,
    mlsId: listing.mlsId,
    mlsSource: listing.mlsSource,
    addressLine1: listing.addressLine1,
    addressLine2: listing.addressLine2 || undefined,
    baths: listing.numBathrooms,
    beds: listing.numBedrooms,
    latitude: listing.latitude,
    longitude: listing.longitude,
    listingStatus: listing.listingStatus?.listingStatus || "Unknown",
    buildingName: undefined, // Not available in SummarySinglePropertyResponse
    city: listing.city,
    description: undefined, // Not available in SummarySinglePropertyResponse
    garageSpaces: undefined, // Not available in SummarySinglePropertyResponse
    hoaFees: undefined, // Not available in SummarySinglePropertyResponse
    hoaFee: undefined, // Not available in SummarySinglePropertyResponse
    floor: undefined, // Not available in SummarySinglePropertyResponse
    listDate: undefined, // Not available in SummarySinglePropertyResponse
    listPrice: listing.listPrice,
    livingSpace: listing.internalSize,
    lotSize: undefined, // Not available in SummarySinglePropertyResponse
    neighborhood: undefined, // Not available in SummarySinglePropertyResponse
    nonGarageSpaces: undefined, // Not available in SummarySinglePropertyResponse
    propertyStyle: undefined, // Deprecated field
    propertyStyles: undefined, // Not available in SummarySinglePropertyResponse
    propertyStyleOther: undefined, // Not available in SummarySinglePropertyResponse
    propertyType: listing.propertyType?.propertyType || "Unknown",
    propertyTypeOther: undefined, // Not available in SummarySinglePropertyResponse
    state: listing.state,
    yearBuilt: undefined, // Not available in SummarySinglePropertyResponse
    zipCode: listing.zipCode,
    renovationType: undefined, // Not available in SummarySinglePropertyResponse
    hasAdditionalLivingSpace: false, // Default value
    additionalLivingSpaceSqFt: undefined, // Not available in SummarySinglePropertyResponse
    images: listing.coverPhotoUrl
      ? [
          {
            id: "0",
            url: listing.coverPhotoUrl,
            cdnUrl: undefined,
            caption: undefined,
          },
        ]
      : [],
    soldPrice: listing.soldPrice,
    soldDate: undefined, // Not available in SummarySinglePropertyResponse
    county: undefined, // Not available in SummarySinglePropertyResponse
    smartResult: undefined, // Not available in SummarySinglePropertyResponse
    hasDoormanAttendance: false, // Not available in SummarySinglePropertyResponse
    listingAgent: {
      name: null,
      dre: null,
      brokerage: null,
      lastSourceUpdateDate: null,
      phone: null, // Not available in SummarySinglePropertyResponse
      email: null, // Not available in SummarySinglePropertyResponse
    },
    isLease: undefined, // Not available in SummarySinglePropertyResponse
    roomsTotal: undefined, // Not available in SummarySinglePropertyResponse
    flipTaxRemarks: undefined, // Not available in SummarySinglePropertyResponse
    recurringCosts: undefined, // Not available in SummarySinglePropertyResponse
  };

  return property;
};
